var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXSombra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2119-8",
    transform: "rotate(45,135.75424,90.214246)",
    style: {
      fill: "#666666"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2123-9",
    transform: "matrix(0.98220641,0,0,1.0124555,3.5329911,-0.32854168)",
    style: {
      fill: "#666666"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#666666",
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeOpacity: 0,
      paintOrder: "markers stroke fill"
    },
    id: "rect2002-3",
    width: 103.80224,
    height: 20.317163,
    x: 94.751862,
    y: 68.339546,
    ry: 9.8507357
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#666666",
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeOpacity: 0,
      paintOrder: "markers stroke fill"
    },
    id: "rect2002-9-3",
    width: 103.80224,
    height: 20.317163,
    x: -130.20602,
    y: 135.55664,
    ry: 9.8507357,
    transform: "rotate(-90.010419)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2119",
    transform: "rotate(45,128.31542,73.43269)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2123",
    transform: "matrix(0.98220641,0,0,1.0124555,3.5329911,-0.32854168)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeOpacity: 0,
      paintOrder: "markers stroke fill"
    },
    id: "rect2002",
    width: 103.80224,
    height: 20.317163,
    x: 94.751862,
    y: 68.339546,
    ry: 9.8507357
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeOpacity: 0,
      paintOrder: "markers stroke fill"
    },
    id: "rect2002-9",
    width: 103.80224,
    height: 20.317163,
    x: -130.20602,
    y: 135.55664,
    ry: 9.8507357,
    transform: "rotate(-90.010419)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSombra);
export default __webpack_public_path__ + "static/media/x_sombra.134a3594ddd7862ab0d4ba926c43c50f.svg";
export { ForwardRef as ReactComponent };